'use client';
import React from 'react';
import PropTypes from 'prop-types';
// mui
import { Box } from '@mui/material';

export default function BlurImageAvatar({ src, alt = 'user avatar', ...props }) {
  const [imgSrc, setImgSrc] = React.useState(src);
  const [isLoading, setIsLoading] = React.useState(true);
  const [hasError, setHasError] = React.useState(false);

  // Handle image load error
  const handleError = () => {
    setHasError(true);
    // Use a placeholder image when the original fails to load
    setImgSrc('/placeholder-image.jpg'); // You should add a placeholder image to your public folder
  };

  // Handle successful load
  const handleLoad = () => {
    setIsLoading(false);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: 40,
        width: 40,
        marginRight:'10px',
        borderRadius: '50%',
        overflow: 'hidden',
        bgcolor: 'grey.200',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        },
        ...(hasError && {
          bgcolor: 'grey.300',
          '&::after': {
            content: `"${alt?.charAt(0).toUpperCase() || '?'}"`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            color: 'text.secondary',
            fontWeight: 'bold'
          }
        }),
        ...(isLoading && {
          '& img': {
            filter: 'blur(5px)',
            transition: 'filter 0.3s ease-out'
          }
        })
      }}
    >
      {!hasError && (
        <img 
          src={imgSrc} 
          alt={alt} 
          onError={handleError}
          onLoad={handleLoad}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      )}
    </Box>
  );
}

BlurImageAvatar.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string
};